/**
 * Detect stale/truncated JS or CSS chunks (post-deploy hash mismatch, empty body,
 * or HTML served as JS). Shared by lazyWithChunkRetry and ErrorBoundary.
 *
 * JSON.parse failures use "Unexpected end of JSON input" — those stay application bugs.
 */
export function isChunkLoadError(error: unknown): boolean {
  const err = error instanceof Error ? error : null
  const msg = err ? err.message : String(error)
  const name = err?.name ?? ''

  if (
    name === 'ChunkLoadError' ||
    msg.includes('Failed to fetch dynamically imported module') ||
    msg.includes('Loading chunk') ||
    msg.includes('ChunkLoadError') ||
    msg.includes('Loading CSS chunk') ||
    msg.includes('Unable to preload CSS')
  ) {
    return true
  }

  // Truncated or HTML-as-JS modules throw SyntaxError, not ChunkLoadError.
  if (name === 'SyntaxError' || error instanceof SyntaxError) {
    if (msg.includes('Unexpected end of JSON input')) return false
    return (
      msg.includes('Unexpected end of input') ||
      msg.includes('Unexpected EOF') ||
      msg.includes("Unexpected token '<'") ||
      msg.includes('Unexpected token <')
    )
  }

  return false
}
